import { createRouter, createWebHistory, Router, RouteRecordRaw } from 'vue-router'
import { IdentificationModule } from "@/store/modules/identification/identification";
import { msalAuth } from '@/services/MsalService';
import { VueNavigationClient } from '@/configs/MsalConfig'
import { AzureIdentificationModule, grabToken } from '@/store/modules/identification/azureIdentification';
// import axios from 'axios';
import { QueryStringModule } from '../store/modules/QueryStringModule';

const routes: Array<RouteRecordRaw> = [
    {
        path: "/Forbidden",
        name: "Forbidden",
        component: () => import(/* webpackChunkName: "forbidden" */ "@/views/Forbidden.vue"),
        meta: { title: "Steel King Industries, Inc." },
    },
    {
        path: "/Welcome",
        name: "Welcome to Dealer Portal",
        component: () => import(/* webpackChunkName: "azureview" */ "@/views/Welcome.vue"),
        meta: { title: "Steel King Industries, Inc." }
    },
    {
        path: "/Login",
        name: "Login Redirect",
        component: { render: () => null }, // For external users
        meta: { title: "Steel King Industries, Inc." }
    },
    {
        path: "/SSO",
        name: "Single Sign On",
        component: { render: () => null }, // For workforce users
        meta: { title: "Steel King Industries, Inc." }
    },
    {
        path: "/Logout",
        name: "Logout",
        component: { render: () => null }, // For all users
        meta: { title: "Steel King Industries, Inc." }
    },
    {
        path: "/customer",
        name: "Customer",
        component: () => import(/* webpackChunkName: "customer" */ "../views/Customer.vue"),
        meta: { title: "Dashboard", authorize: ["Portal-Customer", "SalesAdmin", "IT"] },
    },
    {
        path: '/SiteMap',
        name: 'SiteMap',
        component: () => import(/* webpackChunkName: "sitemap" */ '@/views/SiteMap.vue'),
        meta: { title: 'Site Map', authorize: ["IT"] }
    },
    {
        path: "/ActiveReports",
        name: "Active Reports",
        component: () =>
            import(/* webpackChunkName: "activereports" */ "@/views/admin/ActiveReportEditor.vue"),
        meta: { title: "Active Reports", authorize: ["IT"] },
    },
    {
        path: "/customer/leadtimes",
        name: "Lead Times",
        component: () =>
            import(/* webpackChunkName: "leadtimes" */ "@/views/LeadTimes.vue"),
        meta: { title: "Lead Times", authorize: ["Portal-Customer", "IT"] },
    },
    {
        path: "/customer/requestliterature",
        name: "Request Literature",
        component: () =>
            import(/* webpackChunkName: "requestliterature" */ "@/views/RequestLiterature.vue"),
        meta: { title: "Request Literature", authorize: ["Portal-Customer", "IT"] },
    },
    {
        path: "/customer/announcementarchive",
        name: "Announcement Archive",
        component: () => import(/* webpackChunkName: "announcementarchive" */ "@/views/AnnouncementArchive.vue"),
        meta: { title: "Announcement Archive", authorize: ["Portal-Customer", "IT"] },
    },
    {
        path: "/customer/photodownloads",
        name: "Photo Downloads",
        component: () => import(/* webpackChunkName: "photodownloads" */ "@/views/PhotoDownloads.vue"),
        meta: { title: "Photo Downloads", authorize: ["Portal-Customer", "IT"] },
    },    {
        path: "/customer/logodownloads",
        name: "Logo Downloads",
        component: () => import(/* webpackChunkName: "logodownloads" */ "@/views/LogoDownloads.vue"),
        meta: { title: "Logo Downloads", authorize: ["Portal-Customer", "IT"] },
    },
    {
        path: "/customer/announcement",
        name: "Announcement",
        component: () => import(/* webpackChunkName: "announcementarchive" */ "@/views/Announcement.vue"),
        meta: { title: "Announcement", authorize: ["Portal-Customer", "IT"] },
    },
    {
        path: "/customer/qslisting",
        name: "QSListing",
        component: () => import(/* webpackChunkName: "announcementarchive" */ "@/views/QSListing.vue"),
        meta: { title: "48 Hour Quick Ship", authorize: ["Portal-Customer", "IT"] },
    },
    {
        path: '/admin/users',
        name: 'Users',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Users.vue"),
        meta: { title: "Users", authorize: ["SalesAdmin", "IT"] }
    },
    {
        path: '/admin/pages',
        name: 'Pages',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Pages.vue"),
        meta: { title: "Pages", authorize: ["SalesAdmin", "IT"] }
    },
    {
        path: '/admin/announcements',
        name: 'AnnouncementsAdmin',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Announcements.vue"),
        meta: { title: "Announcements", authorize: ["SalesAdmin", "IT"] }
    },    {
        path: '/admin/photodownloads',
        name: 'PhotoDownloadsAdmin',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/PhotoDownloadsAdmin.vue"),
        meta: { title: "Photo Downloads Admin", authorize: ["SalesAdmin", "IT"] }
    },
    {
        path: '/admin/logodownloads',
        name: 'LogoDownloadsAdmin',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/LogoDownloadsAdmin.vue"),
        meta: { title: "Logo Downloads Admin", authorize: ["SalesAdmin", "IT"] }
    },
    {
        path: '/admin/ibcadoptiontracking',
        name: 'IBC Adoption Tracking',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/QuoteToolAdmin.vue"),
        meta: { title: "IBC Adoption Tracking", authorize: ["IBCLog_Read", "IBCLog_Write", "IT"] }
    },
    {
        path: '/customer/quotetool',
        name: 'Quote Tool',
        component: () => import(/* webpackChunkName: "quotetool" */ "@/views/quoting/QuoteTool.vue"),
        meta: { title: "Quote Tool", authorize: ["Portal-Customer", "IT"] }
    },
    {
        path: '/customer/orderstatus',
        name: 'Order Status',
        component: () => import(/* webpackChunkName: "orderstatus" */ "@/views/OrderStatus.vue"),
        meta: { title: "Order Status", authorize: ["Portal-Customer", "IT"] }
    },
    {
        path: '/admin/quoteapprovals',
        name: 'QuoteApprovalsAdmin',
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/QuoteApprovals.vue"),
        meta: { title: "Quote Approvals", authorize: ["IT", "InsideSalesDirector", "VicePresidentSales", "President"] }
    },
    //{
    //    path: '/customer/teamaccounts',
    //    name: 'Team Members',
    //    component: () => import(/* webpackChunkName: "account" */ "@/views/TeamMembers.vue"),
    //    meta: { title: "Team Members", authorize: ["DealerTeamLeader", "SalesAdmin", "IT"] }
    //},
    {
        path: '/Account/Information',
        name: 'Account Information',
        component: () => import(/* webpackChunkName: "account" */ "@/views/Account/UserInformation.vue"),
        meta: { title: "Account Information", authorize: [] }
    },
    {
        path: "/Identify",
        name: "Identify",
        component: () =>
            import(/* webpackChunkName: "identify" */ "@/views/Identify.vue"),
        meta: { title: "Identify" },
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue') },
    // if you omit the last `*`, the `/` character in params will be encoded when resolving or pushing
    { path: '/:pathMatch(.*)', name: 'bad-not-found', component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue') },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// ---------------------------------------------------------------------------------------------------------------------
// authentication
// ---------------------------------------------------------------------------------------------------------------------

// hook MSAL into router
const client = new VueNavigationClient(router)

const queryPathKey = 'queryPath'

// This callback runs before every route change, including on page load.
router.beforeEach(async (to, from, next) => {
    const authorize = to?.meta?.authorize;
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    //If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title as string

    // initialized
    if ((!msalAuth.workforceIsInitialized.value || !msalAuth.externalIsInitialized.value)) {
        if (to.fullPath.toLowerCase().indexOf('admin') > 0 || to.fullPath.toLowerCase().indexOf('customer') > 0) {
            sessionStorage.setItem(queryPathKey, to.fullPath)
            // QueryStringModule.setPath(to.fullPath) // To help navigate back after logging in
        }
        const accountInternal = await msalAuth.initializeWorkforce(client)
        const accountExternal = await msalAuth.initializeExternal(client)
        if (accountInternal === null && accountExternal === null) {
            return next({ path: '/Welcome' });
        } 
    }

    switch (to.path.toLowerCase()) {
        case '/welcome':
            if (msalAuth.externalAccount.value != null || msalAuth.workforceAccount.value != null) {
                const queryPath = sessionStorage.getItem(queryPathKey)
                let returnUrl = queryPath ?? '/Customer'

                if (returnUrl == '/') {
                    returnUrl = '/Customer'
                } else if (returnUrl.toLowerCase() == '/welcome') {
                    returnUrl = '/Customer'
                }
                if (returnUrl.indexOf('?') > 0) {
                    const queries = parseQuery(returnUrl)
                    return next({ path: returnUrl, query: queries })
                } else {
                    return next({ path: returnUrl })
                }
            }
            break;
        case '/login':
            if (!msalAuth.externalIsInitialized.value) {
                const account = await msalAuth.initializeExternal(client)
                if (account == null) {
                    return next(false)
                }
            }
            // await msalAuth.silentSignIn(null)
            // console.log(msalAuth.externalAccount.value)
            if (msalAuth.externalAccount.value != null) {
                const queryPath = sessionStorage.getItem(queryPathKey)
                let returnUrl = queryPath ?? '/Customer'
                if (returnUrl == '/' || returnUrl.toLowerCase() === '/welcome') {
                    returnUrl = '/Customer'
                }
                if (returnUrl.indexOf('?') > 0) {
                    const queries = parseQuery(returnUrl)
                    return next({ path: returnUrl, query: queries })
                } else {
                    return next({ path: returnUrl })
                }
            } else {
                await msalAuth.signInRedirect(null)
            }
            return next(false)
        case '/sso':
            console.log(msalAuth.workforceIsInitialized.value)
            if (!msalAuth.workforceIsInitialized.value) {
                const account = await msalAuth.initializeWorkforce(client)
                if (account == null) {
                    return next(false)
                }
            }
            // await msalAuth.silentSignIn('steelking.onmicrosoft.com')
            // console.log(msalAuth.workforceAccount.value)
            if (msalAuth.workforceAccount.value != null) {
                const queryPath = sessionStorage.getItem(queryPathKey)
                let returnUrl = queryPath ?? '/Customer'
                if (returnUrl == '/' || returnUrl.toLowerCase() === '/welcome') {
                    returnUrl = '/Customer'
                }
                if (returnUrl.indexOf('?') > 0) {
                    const queries = parseQuery(returnUrl)
                    return next({ path: returnUrl, query: queries })
                } else {
                    return next({ path: returnUrl })
                }
            } else {
                await msalAuth.signInRedirect('steelking.onmicrosoft.com')
            }
            return next(false)
        case '/logout':
            await msalAuth.signOut()
            return next()
    }

    switch (to.path.toLowerCase()) {
        case '/customer/quotetool':
            if (to.query.QuoteID) {
                QueryStringModule.setQuoteID(to.query.QuoteID.toString())
            }
            else {
                QueryStringModule.setQuoteID('0');
            }
            break;
    }

    if (authorize) {
        if (AzureIdentificationModule.authenticated) {
            if (!AzureIdentificationModule.isTokenValid) {
                await grabToken()
                const result = dispatchEvent(new Event('RefreshTokenTimer'))
            }

            // check if route is restricted by role
            if (authorize.length && AzureIdentificationModule.hasTokenData && AzureIdentificationModule.isInRole('Portal-Customer') &&
                !authorize.some((role: string) => AzureIdentificationModule.isInRole(role))
            ) {
                // role not authorized so redirect to home page
                AzureIdentificationModule.setError("403")
                return next({ path: "/Forbidden" });
            } else if (AzureIdentificationModule.isNewUser && to.path.toLowerCase() != '/account/information') {
                console.log('New user detected.')
                return next({ path: "/Account/Information" });
            }
            return next();
        } else if (!AzureIdentificationModule.authenticated) {
            try {
                return next({ path: "/Login" });
            } catch (err) {
                console.log(err)
                AzureIdentificationModule.setError("Unknown")
                console.log('banished :"(')
                return next({ path: "/Forbidden" });
            }
        }
    }

    next();
});

export default router;

function parseQuery(urlString: string): Record<string, string> {
    const url = new URL(urlString, "https://example.com");
    return Object.fromEntries(url.searchParams.entries());
}
